export const locales = {
	optional: 'Document facultatif',
	uploadFile: 'Sélectionner le fichier',
	viewFile: 'Voir le fichier'
};
